import elementStateToggle from './elementStateToggle';

const accordion = {
    init() {
        elementStateToggle.init({
            triggerElementSelector: '.js-accordion-header',
            toggleActiveElement: true,
            removeAllActiveClasses: false,
        });

        if (window.location.hash) {
            const hashTarget = document.querySelector(window.location.hash);
            const accordionHeader = hashTarget.closest('.js-accordion-header');
            if (accordionHeader) {
                accordionHeader.classList.add('active');
            }
        }
    },
};

export default accordion;
